import type { I_Country, I_Location, I_RadiusLocation, I_SearchResult, I_Status } from "../shared/types.ts";

interface I_RadiusResponse {
    locations: I_RadiusLocation[]
    truncated: boolean
}

const toQuery = (params: Record<string, string | number | boolean>): string => {
    const search = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value === "" || value === false || value === undefined || value === null) continue;

        search.set(key, String(value));
    }

    return search.toString();
}

const get = async <T>(path: string): Promise<T> => {
    const response = await fetch(path);
    const body = await response.json();

    if (!response.ok) throw new Error(body?.error || response.statusText);

    return body as T;
}

export const fetchStatus = (): Promise<I_Status> => {
    return get<I_Status>("/api/status");
}

export const fetchCountries = (): Promise<I_Country[]> => {
    return get<I_Country[]>("/api/countries");
}

export const searchLocations = (query: string, countries: string[], includeOrgs: boolean): Promise<I_SearchResult> => {
    return get<I_SearchResult>(`/api/search?${toQuery({ q: query, countries: countries.join(","), includeOrgs })}`);
}

export const fetchRadius = (origin: I_Location, km: number, countries: string[], includeOrgs: boolean): Promise<I_RadiusResponse> => {
    return get<I_RadiusResponse>(`/api/radius?${toQuery({ lat: origin.lat, lon: origin.lon, km, countries: countries.join(","), includeOrgs })}`);
}

export const startImport = (): Promise<{ status: string, rows: number, note: string, durationMs: number }> => {
    return fetch("/api/import", { method: "POST" }).then((response) => response.json());
}

export const fetchSession = (): Promise<{ authRequired: boolean, loggedIn: boolean }> => {
    return get<{ authRequired: boolean, loggedIn: boolean }>("/api/session");
}

export const logout = (): Promise<unknown> => {
    return fetch("/api/logout").then((response) => response.json());
}